import { styled } from '@mui/system';
import { PerlmanGreen } from '../../theme';

export const ButtonContainer = styled('div')(({ theme }) => ({
    marginLeft: '-100px',
    marginBottom: '15px',
    [theme.breakpoints.down('md')]: {
        marginLeft: '0px',
        display: 'inline-block',
    },
}));

export const backButtonStyles = {
    bgcolor: PerlmanGreen,
    boxSizing: 'border-box',
    borderRadius: '10px',
    boxShadow: 'none',
    fontSize: '1rem',
    fontWeight: '700',
    fontFamily: 'brandon-regular,sans-serif',
    textTransform: 'none',
    margin: 'none',
    padding: '3px 20px',
    '&:hover': {
        backgroundColor: PerlmanGreen,
        color: '#000',
        boxShadow: '0px 0px 4px 4px #eee',
    },
};
